import { put, takeLatest } from 'redux-saga/effects'

import * as profileCompletionModule from '../reducks/profileCompletion'
import * as profileCompletionApi from '../apiModules/profileCompletion'

function* fetchCompletionSaga(action) {
  try {
    const response = yield profileCompletionApi.fetchProfileCompletion(action.payload.id)
    yield put(profileCompletionModule.fetchCompletionSuccess(response))
  } catch (error) {}
}

export default function* watchProfileCompletionSaga() {
  yield takeLatest(profileCompletionModule.FETCH, fetchCompletionSaga)
}
